import React, { useEffect, useState } from "react"
import { renderRichText, storyblokEditable } from "gatsby-source-storyblok"
import { getStoryblokApi } from "gatsby-source-storyblok"
import gsap from "gsap"
import InfiniteScroll from "react-infinite-scroll-component"
import AfterContent from "../parts/after_content/after_content.js"
import Background from "../parts/background/background.js"
import Button from "../../components/button/button.js"
import BeforeContent from "../parts/before_content/before_content.js"
import Loading from "../../components/loading/loading.js"
import ScrollTrigger from "gsap/ScrollTrigger"

const NewsItem = ({ post, blok }) => (
  <li className="news-query__item gs_reveal">
    <div className="news-query__item-main">
      <h2 className="news-query__item-title">{post.name}</h2>
      <p className="news-query__item-intro">
        {renderRichText(post.content.intro_text).replace(/(<([^>]+)>)/gi, "")}
      </p>
    </div>
    <Button
      blok={{
        Style: blok.cta_style,
        Label: blok.cta_text,
        content_target: { url: `/${post.full_slug}` },
      }}
    />
  </li>
)

const NewsQuery = ({ blok }) => {
  const storyblokApi = getStoryblokApi()
  const [page, setPage] = useState(1)
  const [posts, setPosts] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  useEffect(() => {
    if (typeof window == "undefined" || window.parent.location !== window.location) {
      // You are in Draft Mode or in the Visual Editor. Skip animation.
      return
    }

    if (!posts.length) {
      gsap.registerPlugin(ScrollTrigger)
      return
    }
    // Content reveal.
    ScrollTrigger.batch(".news-query .gs_reveal", {
      onEnter: el => gsap.set(el, { stagger: 0.2, attr: { in: 1 } }),
      onLeaveBack: el => gsap.set(el, { attr: { in: 0 } }),
    })
  }, [posts])

  const fetchMoreData = () => {
    storyblokApi
      .get("cdn/stories", {
        version: "published",
        per_page: blok.per_page,
        page: page,
        sort_by: "first_published_at:desc",
        filter_query: {
          component: { in: "zignal_news" },
        },
      })
      .then(({ data, total }) => {
        if (page === 1) {
          setTotalPages(Math.ceil(total / blok.per_page))
        }

        const newPosts = data.stories.map(story => ({
          ...story,
          content: story.content,
        }))

        setPosts([...posts, ...newPosts])
        setPage(page + 1)
      })
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => fetchMoreData(), [])

  return (
    <InfiniteScroll
      dataLength={posts.length}
      next={fetchMoreData}
      hasMore={page <= totalPages}
      loading={<Loading />}
    >
      <section
        {...storyblokEditable(blok)}
        key={blok._uid}
        className={"news-query content_block" + ((blok.collapse_top_padding) ? ' collapse-top' : '') + ((blok.collapse_bottom_padding) ? ' collapse-bottom' : '')}
      >
        <Background blok={blok.background_settings} />
        <div className="inner">
          <BeforeContent blok={blok.before_content} />

          <ul className="news-query__items">
            {posts.map(post => (
              <NewsItem key={post.uuid} post={post} blok={blok} />
            ))}
          </ul>

          <AfterContent blok={blok.after_content} />
        </div>
      </section>
    </InfiniteScroll>
  )
}

export default NewsQuery
